// CustomDocuments (used on orders) offers only ASSEMBLY and WAYBILL; ArchiveDocuments offers all of them.
export const DOCUMENT_TYPES = [
    { value: 'ASSEMBLY', label: 'Assembly Instructions' },
    { value: 'WAYBILL', label: 'Waybill' },
    { value: 'COI', label: 'Certificate of Insurance' },
    { value: 'WORKERS_COMP', label: "Workers' Comp" },
    { value: 'W9', label: 'W9' },
    { value: 'AGREEMENT', label: 'Agreement' },
    { value: 'NDA', label: 'Mutual NDA' },
    { value: 'RATES', label: 'Rates' },
    { value: 'MISC', label: 'Miscellaneous' },
];

export const CUSTOM_DOCUMENT_TYPES = ['ASSEMBLY', 'WAYBILL'];

export const TYPE_LABELS = Object.fromEntries(DOCUMENT_TYPES.map((d) => [d.value, d.label]));

// Figma "Key Documents" groups rows under section headers. There is no category column, so the
// groups below are a display-only mapping of the `type` values that already exist — no new data,
// and nothing is invented.
//
// OTHER is the catch-all and has no `types` list: any type missing from this map, plus rows with
// no type at all, land there. That is deliberate — a document must never be filtered out of the
// panel just because its type is unrecognised.
export const DOCUMENT_GROUPS = [
    { key: 'AGREEMENTS', label: 'Agreements & Contracts', types: ['AGREEMENT', 'NDA', 'RATES'] },
    { key: 'INSURANCE', label: 'Insurance', types: ['COI', 'WORKERS_COMP'] },
    { key: 'TAX', label: 'Tax & Compliance', types: ['W9'] },
    { key: 'OPERATIONAL', label: 'Operational', types: ['ASSEMBLY', 'WAYBILL'] },
    { key: 'OTHER', label: 'Other Documents' },
];

// What the design shows that the data cannot support, kept as a record rather than faked:
//
//   · Named required slots ("Mutual NDA", "Master Service Agreement", "Rate Addendum") — this
//     panel lists what exists; the carrier Insurance & Contracts tab owns the expected slots.
//   · "not on file — required" badges — nothing marks a type as required.
//   · The MSA sub-line "term · signed date" — shown on the carrier Insurance & Contracts tab,
//     not in this panel.
//   · "Mark all N remaining on file" — a bulk write with no backing concept at all.
//   · The "Other documents" inline name field — uploads need a file, so naming without one
//     cannot produce a row. The Upload modal already takes a name.
export const UNSUPPORTED_BY_DESIGN = [
    'named-required-slots',
    'required-badges',
    'term-and-signed-date',
    'mark-all-on-file',
    'inline-name-only-add',
];
